module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QBAQgr/tc-custom/9783965373983.jpg?1703222303634",
      "alt": "This image is the cover for the book The Talleyrand Maxim, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Talleyrand Maxim, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Excerpt: \"It's old Mr. Bartle, sir, he whispered. He's in your room there -- dead! Dead? exclaimed Eldrick. Dead! Pratt shook his head again. He came up not so long after you'd gone, sir, he said. Everybody had gone but me -- I was just going. Wanted to see you about something I don't know what. He was very tottery when he came in -- complained of the stairs and the fog. I took him into your room, to sit down in the easy chair. And -- he died straight off. Just, concluded Pratt, just as if he was going quietly to sleep!\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J. S. Fletcher\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joseph Smith Fletcher (7 February 1863 – 30 January 1935) was an English journalist and author. He wrote more than 230 books on a wide variety of subjects, both fiction and non-fiction, and was one of the most prolific English writers of detective fiction. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTBebook Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0